import { useRef, useState } from 'react';
import { Typography } from '@material-ui/core';
import ButtonPrimary from './ButtonPrimary';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

export const ControlledFileInput = ({ acccept, onFileChange, buttonText }) => {
  const [fileName, setFileName] = useState('');
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    fileInputRef?.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileName(file.name);
      onFileChange(file);
    }
  };

  return (
    <div>
      <input
        type="file"
        accept={acccept}
        style={{ display: 'none' }}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      <ButtonPrimary startIcon={<CloudUploadIcon />} onClick={handleButtonClick}>
        {buttonText || "Upload file"}
      </ButtonPrimary>
      {fileName && (
        <Typography variant="body2" style={{ marginTop: '8px' }}>
          Selected file: {fileName}
        </Typography>
      )}
    </div>
  );
};
